export class SpecificX{

  correctProvidedDataConfirmed:boolean;
  carriedOutInAccordanceWith:boolean;
  exercisingResponsibilitiesPledged:boolean;
  privacyProtectionMeasuresTaken:boolean;

}
